
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M14.94 10.11L10.54 14.53L8.94001 12.93C8.65001 12.64 8.17001 12.64 7.88001 12.93C7.59001 13.22 7.59001 13.7 7.88001 13.99L10 16.11C10.29 16.4 10.77 16.4 11.06 16.11L16 11.17C16.29 10.88 16.29 10.4 16 10.11C15.71 9.82 15.23 9.82 14.94 10.11ZM21.18 5.01L18.1 2.45C17.68 2.1 17.05 2.15 16.69 2.58C16.34 3 16.4 3.63 16.82 3.99L19.89 6.55C20.31 6.9 20.94 6.85 21.3 6.42C21.66 6 21.6 5.37 21.18 5.01ZM4.10001 6.55L7.17001 3.99C7.60001 3.63 7.66001 3 7.30001 2.58C6.95001 2.15 6.32001 2.1 5.90001 2.45L2.82001 5.01C2.40001 5.37 2.34001 6 2.70001 6.42C3.05001 6.85 3.68001 6.9 4.10001 6.55ZM12 4C7.03001 4 3.00001 8.03 3.00001 13C3.00001 17.97 7.03001 22 12 22C16.97 22 21 17.97 21 13C21 8.03 16.97 4 12 4ZM12 20C8.14001 20 5.00001 16.86 5.00001 13C5.00001 9.14 8.14001 6 12 6C15.86 6 19 9.14 19 13C19 16.86 15.86 20 12 20Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-alarm-on`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconAlarmOn

    ```js
    <b-new-b-icon-alarm-on />
    ```
</docs>


